module.exports = __webpack_public_path__ + "img/jeremy-p.ca6f7ef9.jpg";